import { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectSnackbar } from 'cart-ui-react/src/autoshipState/selectors';
import { setSnackbar } from 'cart-ui-react/src/autoshipState/autoshipSlice';

const useCloseSnack = () => {
  const dispatch = useDispatch();
  const { message, type, delay } = useSelector(selectSnackbar);
  const timeoutId = useRef(null);

  const handleClose = () => {
    dispatch(setSnackbar({ message: '', type: type, delay: 4500 }));
  };

  const createSnack = () => {
    const tempId = setTimeout(() => {
      if (tempId === timeoutId.current) {
        handleClose();
        timeoutId.current = null;
        return;
      }
      clearTimeout(tempId);
    }, delay);
    timeoutId.current = tempId;
  };

  useEffect(() => {
    if (message) {
      // pulled out into a function to avoid side effects
      createSnack();
    }
  }, [message, timeoutId.current]);

  return handleClose;
};

export default useCloseSnack;
